import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Credit management and purchasing</Typography>

      <p className='mb-5'>
        The Credits page provides an overview of your current Smartix credit allowance and lets you purchase additional credits at any time.
        The page is divided into three areas:
      </p>
      <Typography variant='h6' className='pb-5'>Free Credits</Typography>

      <p className='-mt-2 mb-5'>Every Smartix customer receives a monthly allowance of free credits. This section shows when your next allowance will be added and the maximum number of free credits available each month.
        Free credits do not roll over. On your billing date, any unused free credits are replaced with the new monthly allowance. Purchased credits are kept separately and are not affected by this reset. Smartix always uses your free credits before deducting from purchased credits.
      </p>
      <Typography variant='h6' className='pb-5'>Credit Balance</Typography>

      <p className='-mt-2'>This section gives you a complete view of your current credit position, including:</p>
      <ul>

        <li>Free credits remaining and the date of your next free-credit allocation.</li>
        <li>Purchased credits remaining.</li>
        <li>Your total available credit balance and any available overdraft allowance.</li>
        <li>Details of your most recently purchased credit bundle, including its purchase date, number of credits, price and expiry date.</li>
        <li>Your current Auto Top-Up settings and the bundle that will be purchased automatically if Auto Top-Up is enabled.</li>
        <li>Your email notification threshold, so you can be warned when your credit balance is running low.</li>
      </ul>
      <p className='-mt-2 mb-5'>A link to the pricing page is also provided if you want to see how many credits different Smartix activities consume.</p>

      <Typography variant='h6' className='pb-5'>Purchase a credit bundle</Typography>

      <p className='-mt-2'>
        Additional credits can be purchased whenever you need them. The available bundles are shown with the number of credits included, price and associated overdraft allowance.
        You can switch between VAT-inclusive and VAT-exclusive prices, select the bundle that best matches your expected usage, and purchase it directly from this page.</p>

      <p>When you select a bundle, Smartix also provides an indication of what that amount of credit represents in practical terms — for example, approximately how many new passes could be issued or how many existing passes could be supported at different levels of engagement.
        Purchased credits supplement your monthly free allowance, giving you the flexibility to start small and buy additional capacity as your use of Smartix grows.</p>
    </div>
  )
}

export default HelpText